import React, { Component } from "react";
import {Button, Checkbox} from "carbon-components-react";
import MultiselectTwoSides from 'react-multiselect-two-sides';
import { toast } from "react-toastify";
import { Breadcrumb, Card } from "../../../../components";

import {
  getByDmService,
  getDmService,
  updateDmService,
  insertDmService
} from "../../../../services/Api";



class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options:[],
      selecionados:[],
    };
  }

  componentWillMount = async () => {
    
    await this.getItems();
    await this.getUsers();
  };

  getItems = async () => {
    const { match } = this.props;
    try {
      const data = await getByDmService("/Equipe", match.params.id);
      const selecionados = data && data.usuarios ? data.usuarios.map(p=> p.id) : [];
      this.setState({
        ...data,
        selecionados
      });
    } catch (e) {
      if (match.params.id > 0)
        toast.error("Ocorreu um erro ao carregar os dados");
    }
  }

  getUsers = async () => {
    const { match } = this.props;
    try {
      const data = await getDmService("/Equipe/Usuarios?q=");
      const options = data.map(p=> {return { label: p.nome, value: p.id }})
      this.setState({
        options,
      });
    } catch (e) {
      if (match.params.id > 0)
        toast.error("Ocorreu um erro ao carregar os dados");
    }
  }

  onsubmit = e => {
    e.preventDefault();
    const {selecionados} = this.state;
    if (e.target.checkValidity()) {
      if(selecionados && selecionados.length > 0)
        this.save();
        else {
          toast.warn("Selecione um ou mais usuários")
        }
    }
  };

  save = () => {
    const {
      nome,
      selecionados,
      ativo
    } = this.state;

    const formData = {
      nome,
      ativo,
      usuarios:selecionados.map(p=> { return {id: p, nome:"-"}})
    };
    this.setState({ isSaving: true });
    const { match, history } = this.props;
    const { id } = match.params;
    if (id && id > 0) {
      updateDmService("/Equipe", id, formData)
        .then(data => {
          this.setState({
            isSaving: false,
          });
          toast.success("Dados atualizados com sucesso");
          history.push("/admin/equipes/lista");
        })
        .catch(err => {
          this.handleCatch(err);
        });
    } else {
      insertDmService("/Equipe", formData)
        .then(data => {
          this.setState({
            isSaving: false,
          });
          toast.success("Equipe cadastrada com sucesso");
          history.push("/admin/equipes/lista");
        })
        .catch(err => {
          this.handleCatch(err);
        });
    }
  };

  handleCatch = err => {
    this.setState({ isSaving: false });
    if (typeof err.error.response.data.modelState !== "undefined") {
      let error = "Ocorreu o seguinte erro: ";

      const erros = err.error.response.data.modelState;
      for (const p in erros) {
        let name = p.replace("model.", "");
        name = name[0].toUpperCase() + name.slice(1);
        error += `${name}: ${erros[p]}; `;
      }
      toast.error(error);
    } else {
      toast.error(
        "Ocorreu um erro ao salvar os dados, tente novamente mais tarde"
      );
    }
  };

  onChangeCheck = (val) => {
    console.log(val)
    this.setState({ "ativo": val });
  };

  onChangeText = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleChange = (selecionados) => {
    this.setState({selecionados});
  }

  render() {
    const { match, history } = this.props;
    const isEdit = match.params.id > 0;

    const {
      nome,
      ativo,
      options,
      selecionados
    } = this.state;

    return (
      <div>
        <Breadcrumb
          title={isEdit ? `${nome}` : "Cadastro"}
          description={isEdit ? "Editar Equipe" : "Nova Equipe"}
          renderLeft={(() => (
            <div
              className="breadcrumb-left-actions pointer"
              onClick={() => history.goBack()}
            >
              <svg width="16" height="14" viewBox="0 0 16 14">
                <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
              </svg>
            </div>
          ))()}
        />
        <section className="content-wrapper content-wrapper--large">
          <Card className="center-box">
            <form id="form" onSubmit={this.onsubmit}>
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label">Nome da equipe</label>
                <input
                  type="text"
                  className="bx--text-input"
                  required
                  placeholder="Nome"
                  name="nome"
                  value={nome}
                  onChange={this.onChangeText}
                />
              </div>
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <Checkbox labelText="Ativo" id="ativo" checked={ativo} onChange={(e) => {this.onChangeCheck(e)}} />
              </div>
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <MultiselectTwoSides 
                  options={options} 
                  className="msts_theme_example"
                  availableHeader="Usuários disponíveis"
                  selectedHeader="Selecionados"
                  value={selecionados}
                  searchable
                  onChange={this.handleChange}
                  placeholder="Pesquisar"
                />
              </div>
              <div className="bx--col-xs-12  v-md-margin">
                <Button
                  kind="primary"
                  className="bx--btn--full-width"
                  type="submit"
                >
                  Salvar
                </Button>
              </div>
            </form>
            </Card>
        </section>
      </div>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/screens/admin/Equipe/Edit/Edit.jsx